import { MODULE_LAYOUT_LABELS } from "entities/modules/constants";
import { GamesModuleLayout, StudiosModuleLayout } from "entities/modules/types";
import { SelectOption } from "shared/components/Form/Select";

export const PAGE_THREE_CARDS_BLOCKS = "brands-page-modules-three-card";
export const PAGE_ONE_CARD_BLOCKS = "brands-page-modules-one-card";
export const MODULE_TOP_PRIVACY_TIPS_BLOCK =
  "moduleTemplates-top-privacy-tips-block";

export const moduleTagTypeOptions = [
  { value: "themeTag", label: "Theme Tag" },
  { value: "serviceTag", label: "Service Tag" },
  { value: "metadataTag", label: "Metadata Tag" },
];

export const gamesLayoutOptions: SelectOption[] = [
  {
    value: GamesModuleLayout.VerticalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.VerticalTiles],
  },
  {
    value: GamesModuleLayout.VerticalTilesStacked,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.VerticalTilesStacked],
  },
  {
    value: GamesModuleLayout.HorizontalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.HorizontalTiles],
  },
  {
    value: GamesModuleLayout.HorizontalTilesStacked,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.HorizontalTilesStacked],
  },
  {
    value: GamesModuleLayout.BigHorizontalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.BigHorizontalTiles],
  },
  {
    value: GamesModuleLayout.Top10Games,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.Top10Games],
  },
];

export const gamesLayoutOptionsWithStudioFilter: SelectOption[] = [
  {
    value: GamesModuleLayout.VerticalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.VerticalTiles],
  },
  {
    value: GamesModuleLayout.HorizontalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.HorizontalTiles],
  },
];

export const studiosLayoutOptions: SelectOption[] = [
  {
    value: StudiosModuleLayout.HorizontalLogos,
    label: MODULE_LAYOUT_LABELS[StudiosModuleLayout.HorizontalLogos],
  },
];
